import { AnalyticsInput } from '@core/services/core/analytics/analytics-decorator';
import { CreatePasswordPage } from '@modules/register/pages/create-password/create-password.page';
import { InitialDataPage } from '@modules/register/pages/initial-data/initial-data.page';
import { RgpduePage } from '@modules/register/pages/rgpdue/rgpdue.page';
import { SecurityEmailCodePage } from '@modules/register/pages/security-email-code/security-email-code.page';
import { SecuritySMSCodePage } from '@modules/register/pages/security-sms-code/security-sms-code.page';
import { TecuidamosContactDataPage } from '@modules/register/pages/tecuidamos-contact-data/tecuidamos-contact-data.page';
import { TecuidamosJoinPage } from '@modules/register/pages/tecuidamos-join/tecuidamos-join.page';
import { ValidateClientDuplicateDataPage } from '@modules/register/pages/validate-client-duplicate-data/validate-client-duplicate-data';
import { ValidateEmailPage } from '@modules/register/pages/validate-email/validate-email.page';
import { ValidateIbanPage } from '@modules/register/pages/validate-iban/validate-iban.page';
import { ValidatePhonePage } from '@modules/register/pages/validate-phone/validate-phone.page';

export function getRegisterCommonLiterals() {
  return {
    CD40_page_type: 'process',
    CD131_process_type: 'register',
    CD132_process_name: 'registro area de clientes',
    CD29_section1: 'oim',
    CD30_section2: 'registro area de clientes',
  };
};

export const registerAnalyticInput: AnalyticsInput<
  InitialDataPage |
  RgpduePage |
  ValidatePhonePage |
  ValidateIbanPage |
  ValidateEmailPage |
  ValidateClientDuplicateDataPage |
  SecuritySMSCodePage |
  SecurityEmailCodePage |
  CreatePasswordPage |
  TecuidamosJoinPage |
  TecuidamosContactDataPage
> = {
  literals: getRegisterCommonLiterals(),
  resolvers: [({ analyticsParams }) => {
    return Promise.resolve(analyticsParams);
  }]
};